import { render, staticRenderFns } from "./ProviderFilterButton.vue?vue&type=template&id=5ffcc5c5&scoped=true"
import script from "./ProviderFilterButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderFilterButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderFilterButton.vue?vue&type=style&index=0&id=5ffcc5c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffcc5c5",
  null
  
)

export default component.exports